import React from 'react';
import BreadCrumbs from '../../../common/BreadCrumbs/BreadCrumbs';

export function getUserBreadCrumbs() {
  return [
    {
      label: 'Пользователи',
      to: '/users'
    }
  ];
}

export const UserBreadCrumbs = () => {
  const breadCrumbsLinks = getUserBreadCrumbs();

  return <BreadCrumbs links={breadCrumbsLinks} />;
};
